var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import moment from 'moment';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Chip from '@mui/material/Chip';
import LogoutIcon from '@mui/icons-material/Logout';
import AddIcon from '@mui/icons-material/Add';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PeopleIcon from '@mui/icons-material/People';
import EventIcon from '@mui/icons-material/Event';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { selectEvents, selectIsLoadingEvents, selectCanCreateTestEvents, setEvents, setEventsLoading, setCanCreateTestEvents, } from '../../store/events';
import { getEventStatus } from '../../types';
import { loadEvents, createTestEvent } from '../../api/events';
import { removeToken } from '../../api';
import { useErrorHandler } from '../../hooks/useErrorHandler';
import { colors } from '../../styles/colors';
import { TableSkeleton } from '../../components/atoms/Skeleton';
export const Events = () => {
    const nav = useNavigate();
    const dispatch = useAppDispatch();
    const events = useAppSelector(selectEvents);
    const isLoading = useAppSelector(selectIsLoadingEvents);
    const canCreateTestEvents = useAppSelector(selectCanCreateTestEvents);
    const { errorHandler, setSuccess, setError } = useErrorHandler();
    const [isCreatingTestEvent, setIsCreatingTestEvent] = React.useState(false);
    const logOut = () => {
        removeToken();
        nav('/login');
    };
    const getEvents = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            dispatch(setEventsLoading(true));
            const result = yield loadEvents();
            dispatch(setEvents(result.events));
            dispatch(setCanCreateTestEvents(result.canCreateTestEvents));
        }
        catch (e) {
            if (((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                logOut();
                return;
            }
            errorHandler(e);
        }
        finally {
            dispatch(setEventsLoading(false));
        }
    });
    useEffect(() => {
        getEvents();
    }, []);
    const handleCreateTestEvent = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d;
        try {
            setIsCreatingTestEvent(true);
            const newEvent = yield createTestEvent();
            setSuccess('Тестовая афиша успешно создана');
            nav(`/matches?eventId=${newEvent.id}`);
        }
        catch (e) {
            if (((_b = e === null || e === void 0 ? void 0 : e.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                logOut();
                return;
            }
            const errorMessage = ((_d = (_c = e === null || e === void 0 ? void 0 : e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || 'Ошибка при создании тестовой афиши';
            setError(errorMessage);
        }
        finally {
            setIsCreatingTestEvent(false);
        }
    });
    const onClick = (eventId) => {
        nav(`/matches?eventId=${eventId}`);
    };
    const getStatusColor = (status) => {
        switch (status) {
            case 1:
                return 'warning'; // Запланировано
            case 2:
                return 'info'; // В процессе
            case 3:
                return 'success'; // Завершено
            default:
                return 'default';
        }
    };
    return (_jsx(Box, Object.assign({ sx: {
            minHeight: '100vh',
            backgroundColor: colors.background,
            padding: '24px',
        } }, { children: _jsxs(Box, Object.assign({ sx: {
                maxWidth: '900px',
                margin: '0 auto',
            } }, { children: [_jsxs(Box, Object.assign({ sx: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '32px',
                    } }, { children: [_jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: '16px' } }, { children: [_jsx(Box, Object.assign({ sx: {
                                        width: '48px',
                                        height: '48px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: colors.primary,
                                        borderRadius: '12px',
                                    } }, { children: _jsx(EventIcon, { sx: { fontSize: 28, color: colors.textPrimary } }) })), _jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0410\u0444\u0438\u0448\u0438" })), _jsx(Typography, Object.assign({ variant: "body2", sx: { color: colors.textSecondary } }, { children: moment().format('DD MMMM YYYY') }))] })] })), _jsx(IconButton, Object.assign({ onClick: logOut, sx: {
                                backgroundColor: colors.surfaceVariant,
                                '&:hover': {
                                    backgroundColor: colors.secondaryLight,
                                },
                            } }, { children: _jsx(LogoutIcon, {}) }))] })), canCreateTestEvents && (_jsx(Box, Object.assign({ sx: { marginBottom: '24px' } }, { children: _jsx(Button, Object.assign({ variant: "outlined", startIcon: _jsx(AddIcon, {}), onClick: handleCreateTestEvent, disabled: isCreatingTestEvent, sx: { borderStyle: 'dashed' } }, { children: isCreatingTestEvent ? 'Создание...' : 'Создать тестовую афишу' })) }))), isLoading && _jsx(TableSkeleton, { rows: 5, columns: 4 }), !isLoading && (!events || events.length === 0) && (_jsxs(Paper, Object.assign({ sx: {
                        padding: '60px 24px',
                        textAlign: 'center',
                    } }, { children: [_jsx(CalendarTodayIcon, { sx: {
                                fontSize: 64,
                                color: colors.textHint,
                                marginBottom: '16px',
                            } }), _jsx(Typography, Object.assign({ variant: "h5", sx: { marginBottom: '8px' } }, { children: "\u041D\u0435\u0442 \u0430\u0444\u0438\u0448 \u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F" })), _jsx(Typography, Object.assign({ variant: "body2", sx: { color: colors.textSecondary } }, { children: "\u0410\u0444\u0438\u0448\u0438 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0437\u0434\u0435\u0441\u044C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438" }))] }))), !isLoading && events && events.length > 0 && (_jsx(TableContainer, Object.assign({ component: Paper }, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: "\u0414\u0430\u0442\u0430" }), _jsx(TableCell, { children: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" }), _jsx(TableCell, Object.assign({ align: "center" }, { children: "\u0421\u0442\u0430\u0442\u0443\u0441" })), _jsx(TableCell, Object.assign({ align: "center" }, { children: "\u0418\u0433\u0440\u043E\u043A\u043E\u0432" }))] }) }), _jsx(TableBody, { children: events.map((event) => (_jsxs(TableRow, Object.assign({ onClick: () => onClick(event.id), sx: { cursor: 'pointer' } }, { children: [_jsx(TableCell, { children: _jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: '12px' } }, { children: [_jsx(CalendarTodayIcon, { sx: { fontSize: 18, color: colors.textSecondary } }), _jsx(Typography, Object.assign({ variant: "body2" }, { children: moment(event.date, 'DD.MM.YYYY').format('DD.MM.YYYY') }))] })) }), _jsx(TableCell, { children: _jsx(Typography, Object.assign({ variant: "body1", sx: { fontWeight: 500 } }, { children: event.name })) }), _jsx(TableCell, Object.assign({ align: "center" }, { children: _jsx(Chip, { label: getEventStatus(event.status), color: getStatusColor(event.status), size: "small", variant: "outlined" }) })), _jsx(TableCell, Object.assign({ align: "center" }, { children: _jsxs(Box, Object.assign({ sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                } }, { children: [_jsx(PeopleIcon, { sx: { fontSize: 18, color: colors.textSecondary } }), _jsx(Typography, Object.assign({ variant: "body2" }, { children: event.playerCount }))] })) }))] }), event.id))) })] }) })))] })) })));
};
